import React, { useEffect } from 'react';
import Navigation from '../components/navigation';
import { Footer } from '../components/footer';
import { motion } from 'framer-motion';

const BlogPage = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.trysoro.com/api/embed/a8c063bf-fcd4-456a-8554-2783a9ff5fbd';
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <Navigation />

      <div className="relative bg-slate-900 text-white py-24 mt-20">
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-heading text-5xl md:text-6xl font-bold mb-6 uppercase tracking-wide"
          >
            Blog
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="font-body text-xl text-gray-300 max-w-3xl mx-auto"
          >
            Tips, guides and news about concrete cutting and basement renovations
          </motion.p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div id="soro-blog"></div>
      </div>

      <Footer />
    </div>
  );
};

export default BlogPage;
